import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-clipboard-check-icon',
  standalone: true,
  templateUrl: './clipboard-check-icon.component.html',
  styleUrls: ['./clipboard-check-icon.component.scss']
})
export class ClipboardCheckIconComponent {
  @Input() width: number | string = 20;
  @Input() height: number | string = 20;
}
